export const meterController = (res) => {
  if (res.data.response == "invalid session") {
    return {
      message: "Invalid sessionid",
      type: "error",
    };
  } else if (res.data.response == "failure") {
    return {
      message: "Operation failed. Please try again",
      type: "error",
    };
  } else {
    return {
      message: res.data,
      type: "success",
    };
  }
};
